import { forwardRef, type ButtonHTMLAttributes } from "react";

type Variant = "primary" | "toggle" | "toggle-active" | "danger";

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary:
    "bg-success/10 border border-success text-success hover:bg-success/20",
  toggle:
    "bg-transparent border border-border text-muted hover:border-dim hover:text-text",
  "toggle-active":
    "bg-success/10 border border-success text-success",
  danger:
    "bg-danger/10 border border-danger text-danger hover:bg-danger/20",
};

const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(
  ({ variant = "toggle", className = "", children, ...props }, ref) => (
    <button
      ref={ref}
      className={[
        // Fixed height + leading-none so emoji (🔔) and text children render
        // at the same box height — otherwise the bell button sat a few pixels
        // taller than its text neighbours in TopBar.
        "inline-flex items-center justify-center h-8 rounded px-3 text-sm font-medium leading-none cursor-pointer transition-colors",
        VARIANT_CLASS[variant],
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </button>
  )
);

PillButton.displayName = "PillButton";
export default PillButton;
